import { Visibility } from "@mui/icons-material";
import { Button, Card } from "@mui/material";
import React from "react";

function TicketSolution({ solution }) {
    return (
        <>
            {solution?.pdf_path && (
                <>
                    {/* <a
                        sx={{ width: "100%", dispalay: "flex", marginBottom: "10px" }}
                        href={solution?.pdf_path}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<Visibility />}
                        >
                            Show PDF
                        </Button>
                    </a> */}
                    <Card mt={3}>
                        <embed
                            src={solution?.pdf_path}
                            style={{ width: "100%", height: "90vh" }}
                        />
                    </Card>
                </>
            )}
        </>
    );
}

export default TicketSolution;
